export class MatchFacts {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.name = "MatchFacts";
    this.scene = "Match Facts";
    this.data = [];
    this.page = 6200;
  }

  async preview({ options }) {
    this.onAir = false;
    this.options = options;
    let xml = await this.getVizPage({ page: this.page });

    xml.payload.field.find((item) => {
      return item.attr.name === "000102"; // Number
    }).value = options.game?.home_team?.variables?.badge || "";

    xml.payload.field.find((item) => {
      return item.attr.name === "000202"; // Number
    }).value = options.game?.away_team?.variables?.badge || "";

    xml.payload.field.find((item) => {
      return item.attr.name === "P1021"; // Number
    }).value = options.game?.home_team?.short_name || "";

    xml.payload.field.find((item) => {
      return item.attr.name === "P1022"; // Number
    }).value = options.game?.away_team?.short_name || "";

    let home_goals = options.game?.home_player_stats?.reduce(
      (previous, item) => (previous += parseInt(item.goals) || 0),
      0
    );

    let away_goals = options.game?.away_player_stats?.reduce(
      (previous, item) => (previous += parseInt(item.goals) || 0),
      0
    );

    xml.payload.field.find((item) => {
      return item.attr.name === "000301"; // Number
    }).value = home_goals || 0 || "0";

    xml.payload.field.find((item) => {
      return item.attr.name === "000302"; // Number
    }).value = away_goals || 0 || "0";

    let home_missed_shots = options.game?.home_player_stats?.reduce(
      (previous, item) => (previous += parseInt(item.missed_shots) || 0),
      0
    );

    let away_missed_shots = options.game?.away_player_stats?.reduce(
      (previous, item) => (previous += parseInt(item.missed_shots) || 0),
      0
    );
    xml.payload.field.find((item) => {
      return item.attr.name === "0120"; // Number
    }).value = "";

    xml.payload.field.find((item) => {
      return item.attr.name === "0121"; // Number
    }).value = home_goals + home_missed_shots;

    xml.payload.field.find((item) => {
      return item.attr.name === "0122"; // Number
    }).value = away_goals + away_missed_shots;

    xml.payload.field.find((item) => {
      return item.attr.name === "0220"; // Number
    }).value = "Shot Percentage";

    xml.payload.field.find((item) => {
      return item.attr.name === "0221"; // Number
    }).value =
      (parseInt(
        100 - (home_missed_shots / (home_goals + home_missed_shots)) * 100
      ) || 0) + "%";

    xml.payload.field.find((item) => {
      return item.attr.name === "0222"; // Number
    }).value =
      (parseInt(
        100 - (away_missed_shots / (away_goals + away_missed_shots)) * 100
      ) || 0) + "%";

    xml.payload.field.find((item) => {
      return item.attr.name === "0320"; // Number
    }).value = "Intercepts";

    xml.payload.field.find((item) => {
      return item.attr.name === "0321"; // Number
    }).value = options.game?.home_player_stats?.reduce(
      (previous, item) => (previous += parseInt(item.intercepts) || 0),
      0
    );

    xml.payload.field.find((item) => {
      return item.attr.name === "0322"; // Number
    }).value = options.game?.away_player_stats?.reduce(
      (previous, item) => (previous += parseInt(item.intercepts) || 0),
      0
    );

    xml.payload.field.find((item) => {
      return item.attr.name === "0420"; // Number
    }).value = "Turnovers";

    xml.payload.field.find((item) => {
      return item.attr.name === "0421"; // Number
    }).value = options.game?.home_player_stats?.reduce(
      (previous, item) => (previous += parseInt(item.turnovers) || 0),
      0
    );

    xml.payload.field.find((item) => {
      return item.attr.name === "0422"; // Number
    }).value = options.game?.away_player_stats?.reduce(
      (previous, item) => (previous += parseInt(item.turnovers) || 0),
      0
    );
    xml.payload.field.find((item) => {
      return item.attr.name === "0520"; // Number
    }).value = "Penalties";
    xml.payload.field.find((item) => {
      return item.attr.name === "0521"; // Number
    }).value = options.game?.home_player_stats?.reduce(
      (previous, item) => (previous += parseInt(item.penalties) || 0),
      0
    );

    xml.payload.field.find((item) => {
      return item.attr.name === "0522"; // Number
    }).value = options.game?.away_player_stats?.reduce(
      (previous, item) => (previous += parseInt(item.penalties) || 0),
      0
    );
    xml.payload.field.find((item) => {
      return item.attr.name === "0620"; // Number
    }).value = "Rebounds";
    xml.payload.field.find((item) => {
      return item.attr.name === "0621"; // Number
    }).value =
      options.game?.home_player_stats?.reduce(
        (previous, item) =>
          (previous += parseInt(item.rebounds_offensive) || 0),
        0
      ) +
      options.game?.home_player_stats?.reduce(
        (previous, item) =>
          (previous += parseInt(item.rebounds_defensive) || 0),
        0
      );

    xml.payload.field.find((item) => {
      return item.attr.name === "0622"; // Number
    }).value =
      options.game?.away_player_stats?.reduce(
        (previous, item) =>
          (previous += parseInt(item.rebounds_offensive) || 0),
        0
      ) +
      options.game?.away_player_stats?.reduce(
        (previous, item) =>
          (previous += parseInt(item.rebounds_defensive) || 0),
        0
      );
    xml.payload.field.find((item) => {
      return item.attr.name === "0720"; // Number
    }).value = "Deflections";
    xml.payload.field.find((item) => {
      return item.attr.name === "0721"; // Number
    }).value = options.game?.home_player_stats?.reduce(
      (previous, item) => (previous += parseInt(item.deflections) || 0),
      0
    );

    xml.payload.field.find((item) => {
      return item.attr.name === "0722"; // Number
    }).value = options.game?.away_player_stats?.reduce(
      (previous, item) => (previous += parseInt(item.deflections) || 0),
      0
    );

    await this.updateVizPage({ page: this.page, data: xml, escape: false });
    this.sendPreview("page:read " + this.page);
  }

  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    clearTimeout(this.to);
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
